<div 
    [ngClass]="{
        'is-visible': isVisible,
        'is-hidden': !isVisible
    }"
    class="routes-calendar"
>
    <span class="routes-calendar__title">
        {{'chooseDays'|translate}}
    </span>
    <button (click)="onHide()" class="routes-calendar__close-btn">
        <i class="pi pi-times"></i>
    </button>

    <div class="routes-calendar__info">
        <i class="pi pi-info-circle"></i>
        <span>
            {{'theMaximumDataRangeIs5Days'|translate}}
        </span>
    </div>

    <div class="routes-calendar__switch-dates">
        <div 
            *ngFor="let item of switchDatesRange"
            class="routes-calendar__switch-dates__btn"
        >
            <button (click)="onClickSwitchDateValue(item.type, true)" class="routes-calendar__switch-dates__btn__left">
                <i class="pi pi-angle-left"></i>
            </button>
            <span>
                {{ item.title }}
            </span>
            <button (click)="onClickSwitchDateValue(item.type)" class="routes-calendar__switch-dates__btn__right">
                <i class="pi pi-angle-right"></i>
            </button>
        </div>
    </div>

    <div class="routes-calendar__calendar-wrapper">
        <p-datepicker
            (onSelect)="onSelectDate()"
            [(ngModel)]="rangeDate"
            [maxDate]="maxDateValue"
            [inline]="true"
            selectionMode="range"
            class="max-w-full"
        ></p-datepicker>
    </div>

    <div class="routes-calendar__actions">
        <p-button 
            (click)="submit()"
            [label]="'primeng.apply' | translate"
            class="routes-calendar__submit"
        ></p-button>

        <button
            (click)="resetSelectedDate()"
            class="routes-calendar__actions__clear"
        >
            {{'labels.clear'|translate}}
        </button>
    </div>
</div>
